export default "__VITE_ASSET__c7a62522__"